import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import GlossaryLayout from "../../layouts/GlossaryLayout";

const GlossaryPage = ({ data, t }) => {
  return (
    <Layout
      title={t("glossary.seo.title")}
      description={t("glossary.seo.description")}
    >
      <GlossaryLayout items={data.allWpGlossaryItem.nodes} t={t} />
    </Layout>
  );
};

export default WithI18next()(GlossaryPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    allWpGlossaryItem(
      filter: {
        acfGlobalConfiguration: { gcLinkTo: { in: [$wpGlobalConfig, ".all"] } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { fields: title, order: ASC }
    ) {
      nodes {
        slug
        title
        excerpt
      }
    }
  }
`;
